<div class="row">
  <!-- Liste source des champs -->
  <div class="col-sm-3">
    <div class="card card-outline-success mb-3">
      <div class="card-header card-inverse card-success" style="text-transform: uppercase; font-weight: bold;">
        {{'forms.fields' | translate}}
      </div>
      <div class="card-block scroll-list" style="overflow: auto">
        <div
          cdkDropList
          id="sourceList"
          [cdkDropListData]="vegetables"
          [cdkDropListConnectedTo]="['formContent']"
          (cdkDropListDropped)="drop($event)"
          class="list-group"
        >
          <div
            *ngFor="let item of vegetables"
            cdkDrag
            [cdkDragData]="item"
            class="list-group-item list-group-item-action list-group-item-success"
          >
            {{ item.labelKey ? (item.labelKey | translate) : item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Zone de création du formulaire -->
  <div class="col-sm-9">
    <div class="card card-outline-primary mb-3">
      <div class="card-header card-inverse card-primary" style="text-transform: uppercase; font-weight: bold;">
        {{'forms.dragFields' | translate}}
      </div>
      <p style="text-align: center"><b>* </b> {{'forms.fixedFields' | translate}}</p>
      <div
        cdkDropList
        id="formContent"
        [cdkDropListData]="droppedItems"
        [cdkDropListConnectedTo]="['sourceList']"
        (cdkDropListDropped)="drop($event)"
        class="card-block scroll-list"
        style="overflow: auto"
      >
        <div class="row">
          <div class="col-sm-12">
            <!-- Champs obligatoires fixes -->
            <li
              *ngFor="let item of required_fields; let i = index"
              class="list-group-item list-requred"
              style="border: none;"
            >
              <div class="card card_custom">
                <div class="card-header card_bg_color-required">
                  <div class="card_title">
                    * {{ item.labelKey ? (item.labelKey | translate) : (item.placeholder || item.name) }}
                  </div>
                  <div class="card_actions">
                    <mat-slide-toggle
                      style="font-weight: bold;"
                      [checked]="true"
                      [disabled]="true"
                    >
                      {{'common.required' | translate}}
                    </mat-slide-toggle>
                  </div>
                </div>
              </div>
            </li>

            <!-- Champs dynamiques ajoutés -->
            <li
              *ngFor="let item of droppedItems; let i = index"
              cdkDrag
              class="list-group-item list-requred"
              style="border: none;"
            >
              <div class="card card_custom">
                <div class="card-header card_bg_color">
                  <div class="card_title">
                    <i class="bx bx-move" style="cursor: move; font-size: 20px;"></i>
                    {{ item.labelKey ? (item.labelKey | translate) : (item.placeholder || item.name) }}
                  </div>
                  <div class="card_actions">
                    <mat-slide-toggle
                      style="font-weight: bold;"
                      [checked]="item.is_required === 1"
                      (change)="onRequiredChange($event, i, item.ng_model_name)"
                    >
                      {{'common.required' | translate}}
                    </mat-slide-toggle>
                    <mat-icon
                      (click)="removeItem(item, droppedItems)"
                      style="cursor: pointer;"
                    >{{'common.delete' | translate}}</mat-icon>
                    <span
                      (click)="removeItem(item, droppedItems)"
                      style="cursor: pointer;"
                    >{{'common.delete' | translate}}</span>
                  </div>
                </div>
              </div>
            </li>

            <!-- Anciennes données (si présentes) -->
            <ng-container *ngIf="old_forms">
            <li
              *ngFor="let item of old_forms; let i = index"
              cdkDrag
              class="list-group-item list-requred"
              style="border: none;">
              <div class="card card_custom">
                <div class="card-header card_bg_color">
                  <div class="card_title">
                    <i class="bx bx-move" style="cursor: move; font-size: 20px;"></i>
                    {{ item.labelKey ? (item.labelKey | translate) : (item.placeholder || item.name) }}
                  </div>
                  <div class="card_actions">
                    <mat-slide-toggle
                      style="font-weight: bold;"
                      [checked]="item.is_required === 1"
                      (change)="onRequiredChange($event, i, item.ng_model_name)"
                    >
                      {{'common.required' | translate}}
                    </mat-slide-toggle>
                    <mat-icon
                      (click)="removeItemUpdate(item, old_forms)"
                      style="cursor: pointer;"
                    >{{'common.delete' | translate}}</mat-icon>
                    <span
                      (click)="removeItemUpdate(item, old_forms)"
                      style="cursor: pointer;"
                    >{{'common.delete' | translate}}</span>
                  </div>
                </div>
              </div>
            </li>
            </ng-container>
          </div>

          <!-- Affichage du HTML généré -->
          <div [innerHTML]="test"></div>
        </div>
      </div>
    </div>
  </div>
</div>
